import { useContext } from 'react';
import { ProductContext, productContext } from './Product';
import SlInput from '@shoelace-style/shoelace/dist/react/input/index.js';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip/index.js';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import SlCheckbox from '@shoelace-style/shoelace/dist/react/checkbox/index.js';
import { useTranslation } from 'react-i18next';
import { ErrorField } from '../../base/ErrorField/ErrorField';

const zones = ['A', 'B', 'C', 'D', 'E'] as const;

const ProductShipping = () => {
	const { t } = useTranslation();
	const {
		shippingZoneA,
		setShippingZoneA,
		shippingZoneB,
		setShippingZoneB,
		shippingZoneC,
		setShippingZoneC,
		shippingZoneD,
		setShippingZoneD,
		shippingZoneE,
		setShippingZoneE,
		shippingZoneAOnRequest,
		setShippingZoneAOnRequest,
		shippingZoneBOnRequest,
		setShippingZoneBOnRequest,
		shippingZoneCOnRequest,
		setShippingZoneCOnRequest,
		shippingZoneDOnRequest,
		setShippingZoneDOnRequest,
		shippingZoneEOnRequest,
		setShippingZoneEOnRequest,
		error,
	} = useContext(productContext as React.Context<ProductContext>);

	const values = [shippingZoneA, shippingZoneB, shippingZoneC, shippingZoneD, shippingZoneE];
	const setters = [
		setShippingZoneA,
		setShippingZoneB,
		setShippingZoneC,
		setShippingZoneD,
		setShippingZoneE,
	];
	const onRequestValues = [
		shippingZoneAOnRequest,
		shippingZoneBOnRequest,
		shippingZoneCOnRequest,
		shippingZoneDOnRequest,
		shippingZoneEOnRequest,
	];
	const onRequestSetters = [
		setShippingZoneAOnRequest,
		setShippingZoneBOnRequest,
		setShippingZoneCOnRequest,
		setShippingZoneDOnRequest,
		setShippingZoneEOnRequest,
	];

	return (
		<div className='product__section product__section--shipping'>
			<div className='product__section-form wrapped'>
				<div className='product__section-title product__section-title--shipping'>
					{t('Shipping')}
					<SlTooltip content={t('Shipping helper text')}>
						<SlIcon className='product__section-title-info' name='info-circle' />
					</SlTooltip>
				</div>
				{zones.map((zone, i) => (
					<ErrorField key={zone} name={`shipping-zone-${zone}`} error={error}>
						<>
							<SlInput
								className='product__shipping-zone'
								label={t(`Shipping zone ${zone}`)}
								type='number'
								min='0'
								disabled={onRequestValues[i]}
								onSlInput={(e: any) => {
									const v = e.target.value;
									const num = v.trim() === '' ? undefined : Number(v);
									setters[i](num);
									if (num != null) {
										onRequestSetters[i](false);
									}
								}}
								value={values[i] === undefined ? '' : String(values[i])}
								size='small'
								noSpinButtons
							>
								<div className='product__price-currency' slot='suffix'>
									€
								</div>
							</SlInput>
							<SlCheckbox
								className='product__shipping-on-request'
								checked={onRequestValues[i]}
								onSlChange={() => {
									const newValue = !onRequestValues[i];
									onRequestSetters[i](newValue);
									if (newValue) {
										setters[i](undefined);
									}
								}}
							>
								{t('On request')}
							</SlCheckbox>
						</>
					</ErrorField>
				))}
			</div>
		</div>
	);
};

export { ProductShipping };
